export default __webpack_public_path__ + "static/media/logoHyperMb.247b2ed2.png";